import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data67 from '../../data/data67.json'
import ArticleList from '../../Components/ArticleList';

const SocialOrganizationAssessment: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>社会组织等级评估</h1>
                <ArticleList dataId="67" data={data67 as any} />
            </div>
        } />
    );
};

export default SocialOrganizationAssessment;